import { render, staticRenderFns } from "./BulkUntrashArticles.vue?vue&type=template&id=df2a53b8"
import script from "./BulkUntrashArticles.vue?vue&type=script&lang=js"
export * from "./BulkUntrashArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports